export const stripPhoneValue = (value) => {
  return value.replace(/\D/g, '')
}

// export const phoneMatch = /^380\d{9}$/
export const phoneMatch = /^\d{9}$/
